import React from "react";
import AppContainer from "../AppContainer";

export * from "./config";

const Routes = () => <AppContainer />;

export default Routes;
